<template>
  <v-dialog v-model="deleteScriptDialog" width="30%" persistent>
    <v-card>
      <v-card-title>Delete Script</v-card-title>
      <v-card-text>
        Are you sure you want to delete {{active.name}}?
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn :loading="isLoading" :disabled="isLoading" text color="primary" @click="closeDialog">Cancel</v-btn>
        <v-btn :loading="isLoading" :disabled="isLoading" color="error" @click="deleteScript">Delete Script</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import {ScriptsHttp} from "@/http/ScriptsHttp";

export default {
  name: "DeleteScriptModal",
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapState("scripts", ["deleteScriptDialog", "activeScript"]),
    active: {
      get() {
        return this.activeScript;
      }
    }
  },
  methods: {
    ...mapActions("scripts", ["setScripts", "setActiveScript", "setManageScriptDialog", "setManageDeleteScriptDialog"]),
    ...mapMutations("app", ["setToast"]),
    async closeDialog() {
      await this.setActiveScript({});
      await this.setManageDeleteScriptDialog(false);
    },
    async deleteScript() {
      try {
        this.isLoading = true;
        await ScriptsHttp.archiveScript(this.active._id);
        this.setToast({color: 'success', text: 'Script deleted successfully', show: true});
        await this.setScripts();
        await this.setActiveScript({});
        await this.setManageDeleteScriptDialog(false);
      } catch (err) {
        this.setToast({color: 'error', text: err.response.data, show: true})
      } finally {
        this.isLoading = false;
      }
    }
  }
}
</script>

<style scoped>

</style>
